import React from "react";
import theme from "theme";
import { Theme, Link, Icon, Section } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";
import { FaTwitch, FaTelegramPlane, FaDiscord } from "react-icons/fa";
import { AiFillYoutube } from "react-icons/ai";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"index"} />
		<Helmet>
			<title>
				Chakraland
			</title>
			<meta name={"description"} content={"Web site created using quarkly.io"} />
			<meta property={"og:title"} content={"Chakraland"} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/63a735459faa0f00208ed884/images/3.png?v=2023-01-01T17:47:18.791Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/63a735459faa0f00208ed884/images/3.png?v=2023-01-01T17:47:18.791Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/63a735459faa0f00208ed884/images/3.png?v=2023-01-01T17:47:18.791Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/63a735459faa0f00208ed884/images/3.png?v=2023-01-01T17:47:18.791Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/63a735459faa0f00208ed884/images/3.png?v=2023-01-01T17:47:18.791Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/63a735459faa0f00208ed884/images/3.png?v=2023-01-01T17:47:18.791Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/63a735459faa0f00208ed884/images/3.png?v=2023-01-01T17:47:18.791Z"} />
		</Helmet>
		<Section
			xl-padding="0 0 0 0"
			xl-height="5vh"
			xs-flex-direction="row"
			xs-display="flex"
			xs-height="5vh"
			height="5vh"
		>
			<Override
				slot="SectionContent"
				xl-margin="0px 0 0px -1%"
				xl-width="100%"
				xl-min-width="100%"
				xl-flex-direction="row"
				xl-display="flex"
				xl-justify-content="center"
				xs-display="flex"
				xs-flex-direction="row"
				xs-align-items="center"
				xs-width="100%"
				xs-justify-content="center"
				display="flex"
				flex-direction="row"
				align-items="center"
				justify-content="center"
				width="100%"
				min-width="100%"
				height="100%"
				min-height="100%"
				xs-height="100%"
				xs-min-height="100%"
				margin="0px 0px 0px -1%"
			/>
			<Link
				href="https://www.twitch.tv/chakralounge"
				color="#000000"
				target="_blank"
				xl-padding="2% 1% 1% 1%"
				xl-height="5vh"
				xl-display="flex"
				padding="2% 1% 1% 1%"
				height="5vh"
				display="flex"
				xs-padding="2% 4% 1% 1%"
			>
				<Icon
					category="fa"
					icon={FaTwitch}
					size="5vw"
					color="--lightD1"
					xl-width="2vw"
					xl-height="100%"
					xl-display="flex"
					xs-width="4vw"
					xs-height="auto"
					width="2vw"
					padding="2% 1% 1% 1%"
					height="auto"
					xs-padding="2% 4% 1% 1%"
					xl-padding="2% 1% 1% 1%"
				/>
			</Link>
			<Link
				href="https://t.me/chakralounge"
				color="#000000"
				xl-padding="2% 1% 1% 1%"
				xl-height="5vh"
				xl-display="flex"
				target="_blank"
				padding="2% 1% 1% 1%"
				display="flex"
				height="5vh"
				xs-padding="2% 4% 1% 1%"
			>
				<Icon
					category="fa"
					icon={FaTelegramPlane}
					size="5vw"
					color="--lightD1"
					xl-padding="2% 1% 1% 1%"
					xl-width="2vw"
					xl-height="100%"
					xl-display="flex"
					xs-width="4vw"
					width="2vw"
					padding="2% 1% 1% 1%"
					height="auto"
					xs-padding="2% 4% 1% 1%"
				/>
			</Link>
			<Link
				href="https://discord.gg/Kf4bsnr5F7"
				color="#000000"
				xl-padding="2% 1% 1% 1%"
				xl-height="5vh"
				xl-display="flex"
				target="_blank"
				padding="2% 1% 1% 1%"
				display="flex"
				height="5vh"
				xs-padding="2% 4% 1% 1%"
			>
				<Icon
					category="fa"
					icon={FaDiscord}
					size="5vw"
					color="--lightD1"
					xl-padding="2% 1% 1% 1%"
					xl-height="100%"
					xl-width="2vw"
					xl-display="flex"
					xs-width="4vw"
					width="2vw"
					padding="2% 1% 1% 1%"
					height="auto"
					xs-padding="2% 4% 1% 1%"
				/>
			</Link>
			<Link
				href="https://www.youtube.com/@chakralounge_"
				color="#000000"
				xl-padding="2% 1% 1% 1%"
				xl-height="5vh"
				xl-display="flex"
				target="_blank"
				padding="2% 1% 1% 1%"
				display="flex"
				height="5vh"
				xs-padding="2% 4% 1% 1%"
			>
				<Icon
					category="ai"
					icon={AiFillYoutube}
					size="8vw"
					color="--lightD1"
					xl-padding="2% 1% 1% 1%"
					xl-height="100%"
					xl-width="2vw"
					xl-display="flex"
					xs-width="4vw"
					width="2vw"
					padding="2% 1% 1% 1%"
					height="auto"
				/>
			</Link>
		</Section>
		<Section
			xl-padding="0 0 0 0"
			sm-padding="0 0 0 0"
			padding="0 0 0 0"
			height="auto"
			xl-height="90vh"
		>
			<Override
				slot="SectionContent"
				xl-margin="0px 0 0px 0"
				lg-width="100%"
				lg-height="100%"
				xl-min-width="100%"
				sm-margin="0px 0 0px 0"
				sm-min-width="100%"
				margin="0px 0 0px 0"
				height="100%"
				min-width="100%"
				background="rgba(0, 0, 0, 0) url(https://uploads.quarkly.io/63a735459faa0f00208ed884/images/%D0%BD%D0%BE%D0%B2%D1%8B%D0%B9%D1%87%D0%B0%D0%BA%D1%80%D0%B0%D0%BB%D0%B5%D0%BD%D0%B41.png?v=2023-05-13T03:29:37.529Z) center/contain no-repeat scroll padding-box"
				xs-background="rgba(0, 0, 0, 0) url(https://uploads.quarkly.io/63a735459faa0f00208ed884/images/%D1%84%D0%B8%D0%BD%D0%B0%D0%BB%20%D0%BC%D0%BE%D0%B1%D0%B8%D0%BB%D0%BA%D0%B83.png?v=2023-05-13T03:39:57.926Z) center/contain no-repeat scroll padding-box"
				xl-background="rgba(0, 0, 0, 0) url(https://uploads.quarkly.io/63a735459faa0f00208ed884/images/%D0%BD%D0%BE%D0%B2%D1%8B%D0%B9%D1%87%D0%B0%D0%BA%D1%80%D0%B0%D0%BB%D0%B5%D0%BD%D0%B41.png?v=2023-05-13T03:29:37.529Z) center/contain no-repeat scroll padding-box"
			/>
			<Components.ReactSvg xl-position="relative" xs-display="none">
				<Override slot="Popup">
					<Override
						slot="PopupInner"
						max-width="35vw"
						sm-max-height="62vh"
						xl-max-width="35vw"
						sm-max-width="100vw"
						xs-max-width="100vw"
						xs-max-height="58vh"
						max-height="90vh"
						width="30vw"
						xs-width="100vw"
						xl-padding="1% 1% 1% 1.5%"
						lg-padding="1% 1% 1% 1.5%"
						sm-margin="0 0 0 0"
						padding="1% 1% 1% 1.5%"
						height="fit-content"
						md-padding="1% 1% 1% 1.5%"
						display="flex"
						flex-direction="column"
						sm-padding="1% 1% 1% 1.5%"
						background="#010a13 url(&quot;https://uploads.quarkly.io/63a735459faa0f00208ed884/images/%D0%A1%D0%BD%D0%BE%D0%B2%D0%B0%20%D0%BC%D0%B8%D1%88%D1%83%D1%82%D0%BA%D0%B0.png?v=2022-12-24T19:59:38.294Z&quot;) 50% 50% /100% no-repeat scroll padding-box"
						xl-overflow-y="hidden"
						xl-max-height="90vh"
						lg-overflow-y="hidden"
						overflow-y="hidden"
						lg-max-height="62vh"
						md-max-height="62vh"
						md-overflow-y="hidden"
						sm-overflow-y="hidden"
						xl-width="30vw"
						xl-flex-direction="column"
						xl-min-height="fit-content"
						xl-height="fit-content"
						min-height="90vh"
					/>
					<Override
						slot="Title"
						xl-font="--headline2"
						xl-padding="0px 0px 0 1.5%"
						lg-height="fit-content"
						lg-font="--headline2"
						lg-margin="0 0px 0 0px"
						md-height="fit-content"
						sm-height="fit-content"
						sm-padding="0 0 0 1.5%"
						sm-margin="0 0px 0 0px"
						xs-height="fit-content"
						xs-font="--headlinem"
						font="--headline2"
						padding="0px 0px 0px 1.5%"
						height="fit-content"
						xl-height="fit-content"
						xl-width="20vw"
						lg-width="15vw"
						width="15vw"
						xs-width="60vw"
						md-min-height="fit-content"
						min-height="fit-content"
						md-padding="0px 0px 0 1.5%"
						md-margin="0 0px 0 0px"
					/>
					<Override
						slot="ListItem"
						xl-font="--leads"
						lg-font="--leads"
						md-padding="0px 0px 0px 0"
						xs-font="--leadm"
						font="--lead"
						xs-margin="0 0px 5% 0"
						sm-margin="0px 0px 5% -10%"
						lg-margin="0px 0px 5% -15%"
						margin="0px 0px 5% 0"
						border-width="2px"
						border-color="#000000"
						xl-margin="0px 2% 3% -5%"
						md-margin="0px 0px 5% -10%"
						md-font="--leads"
						sm-font="--leads"
						xl-min-height="fit-content"
					>
						Дилис
					</Override>
					<Override
						slot="CloseBtn"
						lg-width="3vw"
						lg-height="3vw"
						md-width="3vw"
						md-height="3vw"
						sm-width="3vw"
						sm-height="3vw"
						xl-max-height="3vw"
					/>
					<Override slot="PopupWrapper" xl-transform="matrix(1,0,0, 1,0,0)" />
					<Override
						slot="ListItems"
						xl-margin="0px 3% 2% -5%"
						margin="0px 3% 2% -5%"
						xl-min-height="fit-content"
						xl-height="fit-content"
						xl-max-height="fit-content"
						md-height="fit-content"
						md-min-height="fit-content"
						sm-height="fit-content"
						sm-min-height="fit-content"
					/>
					<Override
						slot="Titles"
						xl-height="fit-content"
						xl-max-height="fit-content"
						xl-min-height="fit-content"
						xl-width="20vw"
						xl-font="--headline4"
						md-font="--headline4"
						md-width="20vw"
						sm-width="20vw"
						sm-font="--headline4"
					/>
					<Override
						slot="ListItemz"
						xl-margin="0px 0% 0% -5%"
						margin="0px 0px 5% 0px"
						lg-margin="0px 0px 5% -15%"
						md-margin="0px 0px 5% -10%"
						sm-margin="0px 0px 5% -10%"
					/>
				</Override>
				<Override slot="PopupWrapper" />
			</Components.ReactSvg>
			<Components.ReactSvgm
				position="none"
				xl-position="none"
				md-position="none"
				sm-position="none"
				xs-display="block"
				xl-display="none"
				display="none"
				lg-display="none"
				md-display="none"
				sm-display="none"
			>
				<Override slot="Popup">
					<Override
						slot="PopupInner"
						max-width="25vw"
						sm-max-height="58vh"
						xl-max-width="25vw"
						sm-max-width="100vw"
						xs-max-width="100vw"
						max-height="65vh"
						width="25vw"
						xs-width="100vw"
						sm-height="58vh"
						xl-padding="1% 1% 1% 1.5%"
						xl-height="100%"
						lg-padding="1% 1% 1% 1.5%"
						sm-margin="0 0 0 0"
						sm-padding="1% 1% 1% 1.5%"
						padding="1% 1% 1% 1.5%"
						background="rgb(0, 0, 0) url(&quot;https://uploads.quarkly.io/6394b784f63de4002672039d/images/%D0%A4%D0%B0%D0%BA%D0%B5%D1%80.png?v=2022-12-13T16:46:58.199Z&quot;) 50% 50% /cover no-repeat scroll padding-box"
						height="100%"
						md-padding="1% 1% 1% 1.5%"
						xl-display="flex"
						xl-flex-direction="column"
						display="flex"
						flex-direction="column"
						xl-max-height="65vh"
						xs-overflow-y="hidden"
						xs-max-height="70vh"
					/>
					<Override
						slot="Title"
						xl-font="--headline2"
						xl-padding="0px 0px 0px 1.5%"
						lg-height="fit-content"
						lg-font="--headline2"
						xl-margin="0 0px 0 0px"
						lg-margin="0 0px 0 0px"
						md-height="fit-content"
						md-padding="0 0 0 1.5%"
						lg-padding="0px 0px 0px 1.5%"
						md-margin="0 0px 0 0px"
						sm-height="fit-content"
						sm-padding="0 0 0 1.5%"
						sm-margin="0 0px 0 0px"
						xs-height="fit-content"
						xs-font="--headlinem1"
						font="--headline2"
						padding="0px 0px 0px 1.5%"
						height="fit-content"
						xl-height="fit-content"
						xl-width="15vw"
						lg-width="15vw"
						width="15vw"
						xs-width="60vw"
						xs-min-height="fit-content"
					/>
					<Override
						slot="ListItem"
						xl-margin="0px 0px 5% -1.5%"
						xl-font="--lead"
						lg-font="--lead"
						md-padding="0px 0px 0px 0"
						xs-font="--leadm"
						font="--lead"
						margin="0px 0px 5% -1.5%"
						lg-margin="0px 0px 5% -1.5%"
						md-margin="0px 0px 5% -1.5%"
						xs-padding="0px 3% 0px 0"
					>
						Игрок
					</Override>
					<Override
						slot="CloseBtn"
						lg-width="3vw"
						lg-height="3vw"
						md-width="3vw"
						md-height="3vw"
						sm-width="3vw"
						sm-height="3vw"
						xs-width="10vw"
						xs-height="10vw"
					/>
					<Override
						slot="ListItems"
						xs-min-height="fit-content"
						xs-font="--leadm1"
						xs-height="fit-content"
						xs-max-height="fit-content"
						xs-margin="0px 0px 0px -5%"
					/>
					<Override
						slot="Titles"
						xs-font="--headlinem"
						xs-width="62vw"
						xs-overflow-y="hidden"
						xs-height="fit-content"
						xs-min-height="fit-content"
					/>
					<Override slot="ListItemz" xs-font="--leadm" xs-padding="0px 3% 0px 0px" xs-margin="0px 0px 0px -1.5%" />
				</Override>
				<Override slot="PopupWrapper" />
			</Components.ReactSvgm>
		</Section>
		<Link
			font={"--capture"}
			font-size={"10px"}
			position={"fixed"}
			bottom={"12px"}
			right={"12px"}
			z-index={"4"}
			border-radius={"4px"}
			padding={"5px 12px 4px"}
			background-color={"--dark"}
			opacity={"0.6"}
			hover-opacity={"1"}
			color={"--light"}
			cursor={"pointer"}
			transition={"--opacityOut"}
			quarkly-title={"Badge"}
			text-decoration-line={"initial"}
			href={"https://quarkly.io/"}
			target={"_blank"}
		>
			Made on Quarkly
		</Link>
		<RawHtml>
			<style place={"endOfHead"} rawKey={"63a735459faa0f00208ed882"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"}
			</style>
		</RawHtml>
	</Theme>;
});